import { CSSProperties, FC, PropsWithChildren } from 'react';

import Link from 'next/link';

import { TColorProp } from 'styled-components';

import { satoshi } from '~/common/styles/fonts';

import { Container, TLabelSize } from './styles';

interface ILabelProps extends PropsWithChildren {
  size: TLabelSize;
  color?: TColorProp;
  style?: CSSProperties;
  href?: string;
  title?: string;
}

export const Label: FC<ILabelProps> = ({
  size,
  color = 'neutral.100',
  children,
  style,
  href,
  title,
}) => {
  const Element = (
    <Container
      $size={size}
      $color={color}
      className={satoshi.className}
      style={style}
      title={title}
    >
      {children}
    </Container>
  );

  return href ? (
    <Link href={href} passHref>
      {Element}
    </Link>
  ) : (
    Element
  );
};
